import { useState, useEffect } from 'react';
import logo from '../assets/logo2.png';

const slogans = [
  "Sirviendo las necesidades de la automatización",
  "Innovación y calidad en cada componente",
  "Tu socio estratégico en la industria"
];

const LayoutHeader = ({ setCurrentPage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentSloganIndex, setCurrentSloganIndex] = useState(0);

   const handleNavigation = (page) => {
  setCurrentPage(page);
  window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSloganIndex((prevIndex) => (prevIndex + 1) % slogans.length);
    }, 5000); // Cambia cada 5 segundos
    return () => clearInterval(interval);
  }, []);

  const textColor = 'text-white'; // Siempre texto blanco para header rojo
  const hoverTextColor = 'hover:text-gray-200';
  const buttonBg = 'bg-white';
  const buttonHoverBg = 'hover:bg-gray-100';
  const headerBg = 'bg-red-600'; // Fondo rojo fijo para el header

  return (
    <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${headerBg} shadow-lg`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo y Slogan Dinámico */}
          <div className="flex items-center flex-shrink-0">
            <img 
              src={logo}
              alt="R&M Componentes" 
              className="h-14 mr-4 cursor-pointer transition-all duration-300" 
              onClick={() => setCurrentPage('home')} 
            />
            {/* <span className={`hidden lg:block text-sm transition-opacity duration-1000 ${textColor}`}>
              {slogans[currentSloganIndex]}
            </span> */}
          </div>
          
          {/* Menú de navegación para desktop */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => handleNavigation('home')} className={`relative text-lg font-medium transition-colors duration-300 group ${textColor} ${hoverTextColor}`}>
              Inicio
              <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300`}></span>
            </button>
            <button onClick={() => handleNavigation('about')} className={`relative text-lg font-medium transition-colors duration-300 group ${textColor} ${hoverTextColor}`}>
              Sobre nosotros
              <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300`}></span>
            </button>
            <button onClick={() => handleNavigation('services')} className={`relative text-lg font-medium transition-colors duration-300 group ${textColor} ${hoverTextColor}`}>
              Productos
              <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300`}></span>
            </button>
            <button onClick={() => handleNavigation('news')} className={`relative text-lg font-medium transition-colors duration-300 group ${textColor} ${hoverTextColor}`}>
              Novedades
              <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300`}></span>
            </button>
            <button onClick={() => handleNavigation('contact')} className={`relative text-lg font-medium transition-colors duration-300 group ${textColor} ${hoverTextColor}`}>
              Contactos
              <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300`}></span>
            </button>
            <button onClick={() => handleNavigation('catalogo')} className={`${buttonBg} ${buttonHoverBg} text-red-600 px-6 py-2 rounded-full text-lg font-medium transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg`}>
              Catálogo
            </button>
          </nav>

          {/* Botón de menú móvil */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className={`${textColor} focus:outline-none`}>
              <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Menú móvil */}
      {isOpen && (
        <div className="md:hidden bg-gray-800 bg-opacity-95 backdrop-blur-sm pb-4 transition-all duration-300 ease-in-out">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <button onClick={() => { setCurrentPage('home'); setIsOpen(false); }} className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-white hover:bg-gray-700 transition-colors">Inicio</button>
            <button onClick={() => { setCurrentPage('about'); setIsOpen(false); }} className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-white hover:bg-gray-700">Sobre nosotros</button>
            <button onClick={() => { setCurrentPage('services'); setIsOpen(false); }} className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-white hover:bg-gray-700">Servicios</button>
            <button onClick={() => { setCurrentPage('contact'); setIsOpen(false); }} className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-white hover:bg-gray-700">Contactos</button>
            <button onClick={() => { setCurrentPage('catalogo'); setIsOpen(false); }} className="w-full text-left px-3 py-2 rounded-md text-base font-medium bg-white text-red-600 hover:bg-gray-100 transition-colors">Catálogo</button>
          </div>
        </div>
      )}
    </header>
  );
};
export default LayoutHeader;